import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { StagesComponent } from "../../../../../../common/stages/stages.component";
import { stages } from "../../removal-of-trees-or-shrubs.routes";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import {
  selectApplication,
  selectLoading,
  selectPending
} from "../../../../../../store/selectors/application.selectors";
import { RemovalOfTreesOrShrubsStatementsForm } from "./forms/removal-of-trees-or-shrubs-statements.form";
import { updateApplication } from "../../../../../../store/actions/application.actions";
import { Subscription } from "rxjs";
import { toObservable } from "@angular/core/rxjs-interop";
import { ApplicationAppEntityApplicationRead } from "../../../../../../openapi";
import { SpinnerComponent } from "../../../../../../common/spinner/spinner.component";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ValidationErrorsComponent } from "../../../../../../common/validation-errors/validation-errors.component";
import { AlertComponent } from "../../../../../../common/alert/alert.component";
import { PropertyOwnerStatementContentPipe } from '../../../../../../pipes/property-owner-statement-content.pipe';

@Component({
  selector: 'app-removal-of-trees-or-shrubs-statements-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    AlertComponent,
    PropertyOwnerStatementContentPipe
  ],
  providers: [RemovalOfTreesOrShrubsStatementsForm],
  templateUrl: './removal-of-trees-or-shrubs-statements-section.component.html'
})
export class RemovalOfTreesOrShrubsStatementsSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  private store$: Store = inject(Store);

  public applicationId: string | undefined = this.route.snapshot.params['appId'];

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public form: RemovalOfTreesOrShrubsStatementsForm = inject(RemovalOfTreesOrShrubsStatementsForm);

  private fetchApplication: Subscription = toObservable(this.application).subscribe((app) => {
    if (app) {
      this.form.patchValue(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        successFnc: () => {
          this.router.navigate(['../zgody'], {relativeTo: this.route});
        },
        failureFnc: () => {
        },
        application: this.form.value,
        id: this.applicationId || ''
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../informacje-o-wycince'], {relativeTo: this.route});
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
